import { render } from "./DgWohnungStep5.vue?vue&type=template&id=036c56f6"
import script from "./DgWohnungStep5.vue?vue&type=script&lang=js"
export * from "./DgWohnungStep5.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__